import { Directive, OnInit, SimpleChange } from "@angular/core";
import {
	Input,
	Output,
	OnChanges,
	EventEmitter,
	ElementRef,
	HostListener,
	ChangeDetectorRef,
} from "@angular/core";
@Directive({
	selector: "[makeDraggable]",
})
export class DraggableDirective implements OnInit {
	@Input() dragImage?: string;
	@Input() dragItemIndex?: number;
	@Input() dragData?: any;
	@Input() draggable?: boolean;
	private el: HTMLElement;
	constructor(
		private elementRef: ElementRef,
		private changeDetector: ChangeDetectorRef
	) {
		console.log("DraggableDirective");
		this.el = elementRef.nativeElement;
	}
	ngOnInit() {
		this.el.draggable = this.dragData.dragEnabled ? true : false;
		let _owner = this;
		let imgTag = new Image();
		imgTag.src = _owner.dragImage;

		//(window as any).setDragImageIEPreload(imgTag);
		this.el.ondragover = function (event) {
			event.preventDefault();
		};
		this.el.ondragstart = function (event) {
			//console.log('drag started',event.dataTransfer);
			if (event.dataTransfer) {
				//console.log("event.dataTransfer is true")
				event.dataTransfer.setData("text", _owner.dragItemIndex.toString());
				(event.dataTransfer as any).setDragImage(imgTag, 10, 10);
			}
		};
		this.el.ondragover = function (event) {
			event.stopPropagation();
		};
	}

	ngOnChanges(changes: SimpleChange) {
		if (
			changes &&
			changes.hasOwnProperty("draggable") &&
			changes["draggable"]["currentValue"] != undefined
		) {
			this.el.draggable = this.draggable;
		}
	}
}
